import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashCollectionReverseDepositRequest from "../CashCollectionReverseDepositRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class CashCollectionReverseDepositRequestBase
 * @extends ModelBaseClass
 * @property {string} note
 * @property {number} cashCollectionId (int64)
 * @property {number} toCashAccountId (int64) the person cashAccount that this is being reverse-deposited to
 */
class CashCollectionReverseDepositRequestBase extends ModelBaseClass {
	/**
	 * @type {string} note
	 */
	note;
	/**
	 * @type {number} cashCollectionId (int64)
	 */
	cashCollectionId;
	/**
	 * the person cashAccount that this is being reverse-deposited to
	 * @type {number} toCashAccountId (int64)
	 */
	toCashAccountId;

	/**
	 * Instantiates a new instance of CashCollectionReverseDepositRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashCollectionReverseDepositRequest}
	 */
	static create(genericObject) {
		const newCashCollectionReverseDepositRequest = new CashCollectionReverseDepositRequest();
		newCashCollectionReverseDepositRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashCollectionReverseDepositRequest;
	}

	/**
	 * Instantiates a new array of CashCollectionReverseDepositRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashCollectionReverseDepositRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashCollectionReverseDepositRequestArray = [];
		genericArray.forEach(genericObject => {
			newCashCollectionReverseDepositRequestArray.push(CashCollectionReverseDepositRequest.create(genericObject));
		});
		return newCashCollectionReverseDepositRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('note', 'string'),
	ModelBaseClass.createModelProperty('cashCollectionId', 'integer'),
	ModelBaseClass.createModelProperty('toCashAccountId', 'integer'),
];

export default CashCollectionReverseDepositRequestBase;
